import clientAuth from "../clientAuth";

export default {
    index: () => clientAuth.get("userlist/userlist"),
    destroy: (id) => clientAuth.delete(`userlist/user-destroy/${id}`),
    updateregisterstatus: (id) => clientAuth.post(`notification/register/update/${id}`),
};